import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useAccountFundsTransfersQuery, } from "generated/generated-models";
import { makeNonEmpty } from "core/util/array";
import { CError } from "app/common/CError";
import { Loading } from "app/lib/components/Loading";
import PendingTransfers from "./AccountTransferHome/PendingTransfers";
import RecentTransfers from "./AccountTransferHome/RecentTransfers";
import MobileTransferDetail from "./AccountTransferHome/MobileTransferDetail";
const AccountTransferPage = ({ accountIdOrNumber, recentTransfersToShow = 10, }) => {
    const [transferView, setTransferView] = useState();
    const [isRecentTransfer, setIsRecentTransfer] = useState(false);
    const { data, loading, error } = useAccountFundsTransfersQuery({
        variables: { accountIdOrNumber: accountIdOrNumber },
    });
    const account = data?.accountByIdOrNumber;
    if (loading) {
        return _jsx(Loading, {});
    }
    if (error || account == null) {
        return _jsx(CError, { error: "Could not load funds transfer details" });
    }
    const pendingFundsTransfers = makeNonEmpty(account.PendingAccountFundsTransfers);
    const processedFundsTransfers = makeNonEmpty(account.ProcessedAccountFundsTransfers).slice(0, recentTransfersToShow);
    if (transferView != null) {
        return (_jsx("section", { className: "cap-account-view sub-wrap", children: _jsx(MobileTransferDetail, { transfer: transferView, goBack: () => setTransferView(undefined), interAccountAllowed: account?.CurrentUserAccountAuthority?.Operate || false, isRecentTransfer: isRecentTransfer }) }));
    }
    return (_jsxs("div", { className: "scheduled-transfers", children: [_jsx(PendingTransfers, { interAccountAllowed: account?.CurrentUserAccountAuthority?.Operate || false, directDebitAllowed: account?.CurrentUserAccountAuthority?.DirectDebit || false, pendingTransfers: pendingFundsTransfers || [], setTransferView: (transfer) => {
                    setTransferView(transfer);
                    setIsRecentTransfer(false);
                } }), _jsx(RecentTransfers, { recentTransfers: processedFundsTransfers || [], setTransferView: (transfer) => {
                    setTransferView(transfer);
                    setIsRecentTransfer(true);
                } })] }));
};
export { AccountTransferPage };
